import { render, staticRenderFns } from "./DialogCouponRule.vue?vue&type=template&id=3b8329da&scoped=true&"
import script from "./DialogCouponRule.vue?vue&type=script&lang=js&"
export * from "./DialogCouponRule.vue?vue&type=script&lang=js&"
import style1 from "./DialogCouponRule.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8329da",
  null
  
)

export default component.exports